const ConstLayout = {

    TOP_50: 50, // v6
    TOP_WITHOUT_SUBMENU: 50,
    TOP_65: 65,
    TOP_85: 85,
    TOP_WITH_SUBMENU: 50 + 30,
    TOP_CONTROLS: 45,
    TOP_WITH_SUBMENU_WITh_CONTROLS: 50 + 30 + 45,
    TOP_WITHOUT_SUBMENU_WITH_CONTROLS: 50 + 45

};

// OLD
// const ConstLayout = {
//
//     TOP_50: 50, // v6
//     TOP_WITHOUT_SUBMENU: 55,
//     TOP_65: 65,
//     TOP_WITH_SUBMENU: 55 + 30,
//     TOP_CONTROLS: 45,
//     TOP_WITH_SUBMENU_WITh_CONTROLS: 55 + 30 + 45,
//     TOP_WITHOUT_SUBMENU_WITH_CONTROLS: 55 + 45
//
// };

export default ConstLayout;
